<template>
    <div>
        <!-- Bouton burger pour mobile -->
        <button @click="isOpen = !isOpen"
            class="md:hidden fixed top-4 left-4 z-50 bg-primary text-white py-2 px-3 rounded shadow">
            ☰
        </button>

        <!-- Overlay mobile -->
        <div v-if="isOpen" @click="isOpen = false" class="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden">
        </div>

        <!-- Menu desktop -->
        <div class="hidden md:flex w-64 h-full bg-primary text-white fixed top-0 left-0 p-4 flex-col justify-between">
            <!-- Haut du menu -->
            <div>
                <div class="mb-8">
                    <h2 class="text-2xl font-bold">
                        <span class="font-light">Bonjour,</span> {{ user.nom }}
                    </h2>
                </div>
                <div class="space-y-2">
                    <router-link to="/dashboard" class="block px-6 py-2 rounded-lg transition duration-300"
                        :class="$route.path === '/dashboard' ? 'bg-maincolor-light text-maincolor-dark font-semibold' : 'text-maincolor-light hover:bg-maincolor-light hover:text-maincolor-dark'">
                        Tableau de Bord
                    </router-link>
                    <router-link to="/dashboard/profil" class="block px-6 py-2 rounded-lg transition duration-300"
                        :class="$route.path === '/dashboard/profil' ? 'bg-maincolor-light text-maincolor-dark font-semibold' : 'text-maincolor-light hover:bg-maincolor-light hover:text-maincolor-dark'">
                        Profil
                    </router-link>
                    <router-link to="/faq" class="block px-6 py-2 rounded-lg transition duration-300" target="_blank">
                        FAQ
                    </router-link>
                </div>
            </div>
            <!-- Bas du menu -->
            <div>
                <button @click="logout"
                    class="w-full text-left text-maincolor-light px-6 py-2 rounded-lg transition duration-300 hover:bg-red-700 hover:text-white">
                    Se déconnecter
                </button>
            </div>
        </div>

        <!-- Menu mobile -->
        <aside v-if="isOpen"
            class="md:hidden fixed top-0 left-0 h-full w-64 bg-primary text-white flex flex-col justify-between p-4 z-50 transition-transform duration-300">
            <!-- Haut du menu -->
            <div>
                <div class="mb-8">
                    <h2 class="text-2xl font-bold">
                        <span class="font-light">Bonjour,</span> {{ user.nom }}
                    </h2>
                </div>
                <div class="space-y-2">
                    <router-link to="/dashboard" class="block px-6 py-2 rounded-lg transition duration-300"
                        :class="$route.path === '/dashboard' ? 'bg-maincolor-light text-maincolor-dark font-semibold' : 'text-maincolor-light hover:bg-maincolor-light hover:text-maincolor-dark'"
                        @click="isOpen = false">
                        Dashboard
                    </router-link>
                    <router-link to="/dashboard/profil" class="block px-6 py-2 rounded-lg transition duration-300"
                        :class="$route.path === '/dashboard/profil' ? 'bg-maincolor-light text-maincolor-dark font-semibold' : 'text-maincolor-light hover:bg-maincolor-light hover:text-maincolor-dark'"
                        @click="isOpen = false">
                        Profil
                    </router-link>
                </div>
            </div>
            <!-- Bas du menu -->
            <div>
                <button @click="logout"
                    class="w-full text-left text-maincolor-light px-6 py-2 rounded-lg transition duration-300 hover:bg-red-500 hover:text-white">
                    Se déconnecter
                </button>
            </div>
        </aside>
    </div>
</template>


<script setup>
import { ref, onMounted } from 'vue'

const isOpen = ref(false)
const user = ref({ nom: '' })
const token = localStorage.getItem('token')
const baseUrl = process.env.VUE_APP_BASE_URL

const fetchUser = async () => {
    try {
        const res = await fetch(`${baseUrl}/api/users/me`, {
            headers: { 'Authorization': `Bearer ${token}` }
        })
        if (res.ok) user.value = await res.json()
    } catch (err) {
        console.error('Erreur API user/me:', err)
    }
}

const logout = () => {
    localStorage.removeItem('token')
    window.location.href = '/login'
}

onMounted(fetchUser)
</script>
